<h1 mat-dialog-title>Preise festlegen ({{ anzahlTiere }} Tiere)</h1>
<div mat-dialog-content>
    <p>Bitte geben Sie den Einkaufspreis Brutto für die ausgewählten Tiere ein:</p>

    <mat-form-field appearance="outline" style="width: 100%">
        <mat-label>Einkaufspreis Brutto (€)</mat-label>
        <input
            matInput
            type="number"
            [formControl]="preisCtrl"
            placeholder="0.00"
            step="0.01"
            min="0"
            [attr.data-cy]="'preise_festlegen_preis_input'"
        />
        <mat-error *ngIf="preisCtrl.hasError('required')"> Preis ist erforderlich </mat-error>
        <mat-error *ngIf="preisCtrl.hasError('min')"> Preis muss größer oder gleich 0 sein </mat-error>
    </mat-form-field>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between; width: 100%">
    <button
        mat-flat-button
        color="accent"
        (click)="save()"
        [disabled]="preisCtrl.invalid || isLoading"
        [attr.data-cy]="'preise_festlegen_speichern_button'"
    >
        <mat-spinner diameter="20" *ngIf="isLoading" style="margin-right: 8px"></mat-spinner>
        Speichern
    </button>
    <div style="display: flex; align-items: center; gap: 12px">
        <button
            mat-stroked-button
            color="warn"
            (click)="deletePrices()"
            [disabled]="isLoading"
            [attr.data-cy]="'preise_festlegen_loeschen_button'"
        >
            <mat-icon>delete</mat-icon>
            Preise löschen
        </button>
        <button mat-button (click)="close()" [disabled]="isLoading" [attr.data-cy]="'preise_festlegen_abbrechen_button'">
            Abbrechen
        </button>
    </div>
</div>
